import { render, staticRenderFns } from "./AdminLoanTypes.vue?vue&type=template&id=04ab691d"
import script from "./AdminLoanTypes.vue?vue&type=script&lang=js"
export * from "./AdminLoanTypes.vue?vue&type=script&lang=js"
import style0 from "./AdminLoanTypes.vue?vue&type=style&index=0&id=04ab691d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports